import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router';
import { authRequireNewPasswordState, FormStatus, InputKV, ButtonKV } from './components';
import { loginFlowUserState, AuthHeader, AuthFooter, ButtonBorderedKVBase } from '@/presentation/components';
import { useRecoilState, useResetRecoilState } from 'recoil';
import AuthLayout from '@/presentation/components/auth-layout/auth-layout';
import { IconDone, IconEye, IconEyeSlash } from '@/presentation/components/icons';
import Styles from './new-password-required-styles.scss';
const NewPasswordRequired = ({ validation, authentication }) => {
    var _a, _b, _c, _d;
    const resetLoginState = useResetRecoilState(authRequireNewPasswordState);
    const [state, setState] = useRecoilState(authRequireNewPasswordState);
    const [loginFlowUser] = useRecoilState(loginFlowUserState);
    // internal state
    const [showPassword, setShowPassword] = useState(false);
    const validate = (field) => {
        const { newPassword } = state;
        const formData = { newPassword };
        setState(prev => (Object.assign(Object.assign({}, prev), { [`${field}Error`]: validation.validate(field, formData) })));
        setState(prev => (Object.assign(Object.assign({}, prev), { isFormInvalid: !!prev.newPasswordError })));
    };
    useEffect(() => resetLoginState(), []);
    useEffect(() => {
        if (state.newPassword)
            validate('newPassword');
    }, [state.newPassword]);
    const handleSubmit = (event) => {
        event.preventDefault();
        try {
            if (state.isLoading || state.isFormInvalid) {
                return;
            }
            setState(prev => (Object.assign(Object.assign({}, prev), { isLoading: true })));
            authentication
                .setNewPassword({
                user: loginFlowUser,
                password: state.newPassword
            })
                .then(() => {
                // navigate('/');
                setState(prev => (Object.assign(Object.assign({}, prev), { allDone: true })));
            })
                .catch(err => {
                setState(prev => (Object.assign(Object.assign({}, prev), { mainError: err.message, isLoading: false })));
                console.log(err);
            });
        }
        catch (error) {
            setState(Object.assign(Object.assign({}, state), { isLoading: false, mainError: error.message }));
        }
    };
    const toggleSP = () => setShowPassword(!showPassword);
    if (!loginFlowUser)
        return React.createElement(Navigate, { to: "/login", replace: true });
    const firstName = ((_b = (_a = loginFlowUser === null || loginFlowUser === void 0 ? void 0 : loginFlowUser.challengeParam) === null || _a === void 0 ? void 0 : _a.userAttributes) === null || _b === void 0 ? void 0 : _b.given_name) || '';
    const lastname = ((_d = (_c = loginFlowUser === null || loginFlowUser === void 0 ? void 0 : loginFlowUser.challengeParam) === null || _c === void 0 ? void 0 : _c.userAttributes) === null || _d === void 0 ? void 0 : _d.family_name) || '';
    return (React.createElement(AuthLayout, null,
        React.createElement(AuthHeader, null),
        React.createElement("div", { className: Styles.loginWrap },
            React.createElement("div", { className: Styles.imgWrap },
                React.createElement("img", { className: Styles.imgSrc })),
            React.createElement("div", { className: Styles.formWrap }, state.allDone ? (React.createElement(AllDone, null)) : (React.createElement("form", { method: "post", onSubmit: handleSubmit, className: Styles.formClass },
                React.createElement("div", { className: Styles.mainPart },
                    React.createElement(FormStatus, null),
                    React.createElement("div", { className: Styles.welcomeMsj },
                        "Welcome,\u00A0",
                        React.createElement("b", { style: { color: '#00A3FF' } }, ` ${firstName} ${lastname}`)),
                    React.createElement("div", null,
                        React.createElement("h2", { className: Styles.title }, "Set your password"),
                        React.createElement("div", { className: Styles.text }, "Password must contain at least 8 characters, one capital letter, number and special symbol.")),
                    React.createElement("div", { className: Styles.inputWrap },
                        React.createElement(InputKV, { required: true, type: showPassword ? 'text' : 'password', name: "newPassword", placeholder: "**********", label: "YOUR PASSWORD", hideRequiredDot: true, rightIcon: showPassword ? (React.createElement(IconEye, { style: { cursor: 'pointer' }, width: 24, height: 24, onClick: toggleSP })) : (React.createElement(IconEyeSlash, { style: { cursor: 'pointer' }, width: 24, height: 24, onClick: toggleSP })) })),
                    React.createElement(ButtonKV, { type: "submit", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)", width: 140, height: 56 }, 'Set Password')))))),
        React.createElement(AuthFooter, null)));
};
const AllDone = () => {
    const navigate = useNavigate();
    const [loginFlowUser] = useRecoilState(loginFlowUserState);
    const onContinue = () => {
        var _a, _b, _c, _d;
        if ((_b = (_a = loginFlowUser === null || loginFlowUser === void 0 ? void 0 : loginFlowUser.challengeParam) === null || _a === void 0 ? void 0 : _a.userAttributes) === null || _b === void 0 ? void 0 : _b.email) {
            navigate(`/login?email=${encodeURIComponent((_d = (_c = loginFlowUser === null || loginFlowUser === void 0 ? void 0 : loginFlowUser.challengeParam) === null || _c === void 0 ? void 0 : _c.userAttributes) === null || _d === void 0 ? void 0 : _d.email)}`);
        }
        else {
            navigate(`/login`);
        }
    };
    return (React.createElement("div", { className: Styles.formClass },
        React.createElement("div", { className: Styles.mainPartAE },
            React.createElement("div", null,
                React.createElement(IconDone, null)),
            React.createElement("h1", null, "All Done"),
            React.createElement("div", { className: Styles.allDoneText }, "Now you can login with your new password"),
            React.createElement(ButtonBorderedKVBase, { type: "button", onClick: onContinue }, "Continue"))));
};
export default NewPasswordRequired;
